import React from 'react';
import {Grid, Row, Button} from 'react-bootstrap';
import {LexemeEditingLevel} from './../../editor/LexemeHelper';
import {LexemeNavigator} from './../../../../dict-components/components';
import {getLexemeProperties} from './../../LexemePage';
import {SubEntryCombo} from './../../../../dict-components/components';
import './../../../../lexeme/page/parts/03_Subentries/parts/LexemeSenses.css'
import './../../../../_css/lexeme.css';

import stylesLexemeSenses from './../../../../_css/dictionary/lexemeParts/lexemeSenses.module.css';


export class SemanticUnitAddTranslation extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            translationgId: ""
        };
    }



    render() {

        const item = typeof this.props.additionalData !== 'undefined' && typeof this.props.additionalData.phraseItem !== 'undefined' ? this.props.additionalData.phraseItem : this.props.item;

        return <Grid className={stylesLexemeSenses['sense-move-grid']} fluid>
            <LexemeNavigator pageStatus={LexemeEditingLevel.TRANSLATION_SELECTOR}
                             startItem={item}
                             context={this.props.context}
                             callbackParent={(selectableItem) => {}}/>
        </Grid>
    }
}